import { CardLinkTranslation } from "@models/card-link-translation.model";
import { normalizeLink } from "@utils/sharedFunctions";
import { useTranslation } from "react-i18next";

// Helper per inviare messaggi a React Native
const postToNative = (type: string, data: object) => {
  const msg = JSON.stringify({ type, data });
  if ((window as any).ReactNativeWebView) {
    (window as any).ReactNativeWebView.postMessage(msg);
  } else {
    // Fallback browser normale (fuori dall'app)
    if (type === 'OPEN_URL' && 'url' in data) {
      window.open((data as any).url, '_blank');
    }
  }
};

export default function CardLink(props: { sponsoredLinkTranslation: CardLinkTranslation }) {
  const { t } = useTranslation();
  if (!props) return null;
  const { currency, minPrice, maxPrice, title, distance, cardLink, details, fullAddress } = props.sponsoredLinkTranslation;

  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();
    const url = normalizeLink(cardLink?.link) ?? `https://www.google.com/search?q=${title}`;
    postToNative('OPEN_URL', { url });
  };

  return (
    <a
      href={normalizeLink(cardLink?.link) ?? `https://www.google.com/search?q=${title}`}
      target="_blank"
      className="w-full text-decoration-none text-black"
      onClick={handleClick} // ← intercetta il click
      rel="noreferrer noopener"
    >
      <img src={`data:image/png;base64,${cardLink?.photo}`} alt={title} />
      <div className="p-4">
        <h3 className="text-lg font-semibold text-black">{title}</h3>
        {cardLink?.recommended ? (
          <span className="d-flex">
            {t("text.recommended")}
            <img src="/images/star.png" style={{ width: "25px", height: "25px", marginLeft: "20px" }} />
          </span>
        ) : " "}
        {!!distance && (
          <div className="flex items-center text-gray-500 text-sm mt-1 mb-3">
            <span>{distance}{!!fullAddress ? `, ${fullAddress}` : ""}</span>
          </div>
        )}
        <p className="text-gray-600 text-sm leading-relaxed">{details}</p>
      </div>
    </a>
  );
}